import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="resolved-configuration-preview"
export default class extends Controller {
  static values = { url: String }

  reload(event) {
    clearTimeout(this.debounceTimer)
    if (this.abortController) this.abortController.abort()

    this.debounceTimer = setTimeout(() => {
      this.abortController = new AbortController()
      const predicateId = event.target.value
      get(this.urlValue, {
        query: { predicate_id: predicateId },
        responseKind: "turbo-stream",
        signal: this.abortController.signal
      })
    }, 200)
  }

  disconnect() {
    clearTimeout(this.debounceTimer)
    if (this.abortController) this.abortController.abort()
  }
}
